import { PaymentPlanAdapters } from '../adapters';
import { PaymentPlansApi } from '../clients';

export const getPaymentPlans = async () => {
  const response = await PaymentPlansApi.getPaymentPlans();

  return PaymentPlanAdapters.toGetPaymentPlansResult(response);
};
